/* global XMLHttpRequest */

import aecConfig from "./appEventCollectorConfig";

const sendEventToAec = function ({ tag, event: userEvent }) {
  var event = {
    env: aecConfig.env,
    app: aecConfig.app,
    ...userEvent,
  };

  var url = aecConfig.url.replace(/\/$/, "");

  var xhr = new XMLHttpRequest();

  xhr.open("POST", url + "/event/" + tag);
  xhr.withCredentials = true;

  var payload;
  if (typeof FormData === "function") {
    payload = new FormData();
    Object.keys(event).forEach(function (key) {
      if (typeof event[key] !== "undefined") {
        payload.append(key, event[key]);
      }
    });
  } else {
    // Fall back to JSON body if formdata is not supported
    xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    payload = JSON.stringify(event);
  }

  xhr.send(payload);
};

export default sendEventToAec;
